import type { FulfillmentEntry, OrderFulfillmentResponse } from '@/lib/api-types'
import { fulfillmentChip } from '@/lib/status'

/**
 * Defensive read of the Apex fulfillment DTO. The map is a passthrough the
 * org owns — entries may be missing (line not on the board) and fields may
 * drift, so everything is checked before it renders. Absent or unreadable
 * lines simply show no fulfillment chip.
 */
export interface LineFulfillment {
  label: string
  chipClasses: string
  /** Optional human detail from Apex, e.g. "Produced · batch B-1042". */
  detail: string | null
}

function stringField(entry: FulfillmentEntry, key: string): string | null {
  const value = entry[key]
  return typeof value === 'string' && value.trim() !== '' ? value : null
}

export function lineFulfillmentFor(
  map: OrderFulfillmentResponse | undefined,
  lineId: string,
): LineFulfillment | null {
  const entry = map?.[lineId]
  if (!entry || typeof entry !== 'object') return null
  const status = stringField(entry, 'status')
  if (!status) return null
  const chip = fulfillmentChip(status)
  if (!chip) return null
  return { label: chip.label, chipClasses: chip.className, detail: stringField(entry, 'statusDetail') }
}
